




























import { defineComponent, ref, computed, watch, onMounted } from '@vue/composition-api';

  export default defineComponent({
    name: 'SizeSelectors',
    props: {
      selects: { type: Object, default: () => {} },
    },
    setup(props, context) {
      const selectedValue = ref(props.selects.value);

      watch(selectedValue, (newVal) => {
        context.emit('selectedValue', newVal);
      });

      onMounted(() => {
        context.emit('selectedValue', selectedValue.value);
    });

      const sizeDescription = computed(() => {
        return props.selects.options.find((item) => item.key === selectedValue.value).htc;
      });

      return { 
        sizeDescription,
        selectedValue,
        hasSizeDesciption: computed(() => props.selects && props.selects.options && props.selects.options[0] && props.selects.options[0].htc),
      }
    }
  });
